<header>
  <button *ngIf="isMobileDevice" class="hamburger-btn" aria-label="Toggle menu" (click)="toggleSidebar.emit()">
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
  </button>
  <app-header-elements [currentUser]="currentUser"></app-header-elements>
</header>
